import { Component, output, input, computed } from "@angular/core";
import { IconFeature } from "../../../shared/contract/Module/DataMode";
import { MODULE_NAMES } from "src/app/shared/consts/icon-features";
import { MatRipple } from "@angular/material/core";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "app-task-icon",
  templateUrl: "./task-icon.component.html",
  styleUrls: ["./task-icon.component.scss"],
  imports: [MatRipple, MatTooltip, MatIcon, TranslocoPipe]
})
export class TaskIconComponent {
  taskIconClicked = output<void>();
  config = input<IconFeature>();

  titleTranslationKey = computed(() => {
    const config = this.config();
    if (!config?.Module) return "";

    switch (config.Module) {
      case MODULE_NAMES.Rvm:
        return "Title.MainTitle.RvmRealEstate.Title";
      case MODULE_NAMES.LineMeasurement:
        return "Module.SpatialInformation.TaskBar.LineMeasurement";
      case MODULE_NAMES.PolygonMeasurement:
        return "Module.SpatialInformation.TaskBar.PolygonMeasurement";
      case MODULE_NAMES.CircleMeasurement:
        return "Module.SpatialInformation.TaskBar.CircleMeasurement";
      default:
        return "";
    }
  });
}
